export const HOSPITAL_LIST_REQUEST = "HOSPITAL_LIST_REQUEST";

export const GET_HOSPITAL_BASIC_INFO_REQUEST = "GET_HOSPITAL_BASIC_INFO_REQUEST";
export const GET_HOSPITAL_DEMOGRAPHIC_INFO_REQUEST = "GET_HOSPITAL_DEMOGRAPHIC_INFO_REQUEST";
export const GET_HOSPITAL_OWNERSHIP_INFO_REQUEST = "GET_HOSPITAL_OWNERSHIP_INFO_REQUEST";
export const GET_HOSPITAL_OTHER_DETAILS_REQUEST = "GET_HOSPITAL_OTHER_DETAILS_REQUEST";
export const GET_HOSPITAL_HOSTEL_DETAILS_REQUEST = "GET_HOSPITAL_HOSTEL_DETAILS_REQUEST";
export const GET_HOSPITAL_SOCIAL_INFO_REQUEST = "GET_HOSPITAL_SOCIAL_INFO_REQUEST";
export const GET_HOSPITAL_DOCUMENT_INFO_REQUEST = "GET_HOSPITAL_DOCUMENT_INFO_REQUEST";

export const HOSPITAL_ACTIVE_DEACTIVE_REQUEST = "HOSPITAL_ACTIVE_DEACTIVE_REQUEST";
export const HOSPITAL_STATUS_UPDATE_REQUEST = "HOSPITAL_STATUS_UPDATE_REQUEST";
export const HOSPITAL_SAVE_QUERY_REQUEST = "HOSPITAL_SAVE_QUERY_REQUEST";
export const HOSPITAL_SAVE_SUBSCRIPTION_MAPPING_REQUEST = "HOSPITAL_SAVE_SUBSCRIPTION_MAPPING_REQUEST";
